var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_5163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.8222C7.45 16.8222 6.97917 16.6264 6.5875 16.2347C6.19583 15.8431 6 15.3722 6 14.8222V13.5722C5.05 12.9222 4.3125 12.0889 3.7875 11.0722C3.2625 10.0556 3 8.97224 3 7.82224C3 5.87224 3.67917 4.21807 5.0375 2.85974C6.39583 1.5014 8.05 0.822235 10 0.822235C11.95 0.822235 13.6042 1.5014 14.9625 2.85974C16.3208 4.21807 17 5.87224 17 7.82224C17 8.97224 16.7375 10.0514 16.2125 11.0597C15.6875 12.0681 14.95 12.9056 14 13.5722V14.8222C14 15.3722 13.8042 15.8431 13.4125 16.2347C13.0208 16.6264 12.55 16.8222 12 16.8222H8ZM8 14.8222H12V12.5222L12.85 11.9222C13.5333 11.4556 14.0625 10.8597 14.4375 10.1347C14.8125 9.40974 15 8.6389 15 7.82224C15 6.4389 14.5125 5.25974 13.5375 4.28474C12.5625 3.30974 11.3833 2.82224 10 2.82224C8.61667 2.82224 7.4375 3.30974 6.4625 4.28474C5.4875 5.25974 5 6.4389 5 7.82224C5 8.6389 5.1875 9.40974 5.5625 10.1347C5.9375 10.8597 6.46667 11.4556 7.15 11.9222L8 12.5222V14.8222ZM8 20.8222C7.71667 20.8222 7.47917 20.7264 7.2875 20.5347C7.09583 20.3431 7 20.1056 7 19.8222V18.8222H13V19.8222C13 20.1056 12.9042 20.3431 12.7125 20.5347C12.5208 20.7264 12.2833 20.8222 12 20.8222H8Z",
    fill: "#FF8F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_5163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.822235)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.cbab9a5acd5fe0f503d374ce29e05119.svg";
export { ForwardRef as ReactComponent };